import {
  ReceiptHistoryData,
  SessionHistoryData,
} from 'components/history/HistoryContent';
import { Dictionary } from 'lodash';
import { ParkingSession, Receipt } from 'types/generatedSchemaTypes';

export type HistoryScreenName =
  | 'PARKING_AND_CHARGING'
  | 'PREPAID_AND_PERMIT'
  | 'SUBSCRIPTION';
export type HistoryType = 'failed' | 'free' | 'billing' | 'other' | 'default';

export const getReceiptHistoryData = (
  groupedHistory: Dictionary<Receipt[] | [Receipt, ...Receipt[]]>
) => {
  const data: ReceiptHistoryData = [];
  for (const [key, value] of Object.entries(groupedHistory)) {
    data.push({ title: key, data: value, groupIndex: data.length });
  }
  return data;
};

export const getSessionData = (
  groupedHistory: Dictionary<
    ParkingSession[] | [ParkingSession, ...ParkingSession[]]
  >
): SessionHistoryData => {
  return Object.entries(groupedHistory).map(([key, value], index) => ({
    title: key,
    data: value,
    groupIndex: index,
  }));
};
